import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { SUBSCRIBE_EMAIL } from '../core/schema/mutation/email-subscription.mutation';

@Injectable({ providedIn: 'root' })
export class EmailSubscriptionService {
  constructor(private apollo: Apollo) {}

  /** Validates the email format on the client side before sending to server. */
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email?.trim());
  }

  /** Subscribe an email to the newsletter. */
  subscribe(email: string): Observable<any> {
    return this.apollo.mutate({
      mutation: SUBSCRIBE_EMAIL,
      variables: { email: email.trim().toLowerCase() },
    });
  }
}
